


// import React, { useEffect, useState, useRef, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "../api/axiosAuth";
// import io from "socket.io-client";
// import { useAuth } from "../context/AuthContext";
// import { API } from "../components/config"; // ✅ Importación solicitada
// import "../style/Header.css";
// import { FiBell, FiMessageSquare, FiLogOut } from "react-icons/fi";

// // Usamos la API de la configuración, con el fallback de la IP de AWS si fuera necesario
// const API_URL = API || "http://3.236.217.225:5001";

// export default function Header() {
//   const { user, token, logout, refreshUser } = useAuth();
//   const navigate = useNavigate();

//   const [notifications, setNotifications] = useState([]);
//   const [showNotifDropdown, setShowNotifDropdown] = useState(false);
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   const [showChat, setShowChat] = useState(false);
//   const [chatMessages, setChatMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [logoConfig, setLogoConfig] = useState(null);

//   const chatEndRef = useRef(null);
//   const socketRef = useRef(null);

//   /* ================= NOTIFICACIONES ================= */
//   useEffect(() => {
//     if (!user || !token) return;

//     const fetchNotificaciones = async () => {
//       try {
//         const res = await axios.get("/notifications");
//         setNotifications(res.data || []);
//       } catch (err) {
//         console.error("❌ Error cargando notificaciones:", err.message);
//       }
//     };

//     fetchNotificaciones();
//   }, [user, token]);

//   /* ================= CONFIG LOGO ================= */
//   useEffect(() => {
//     if (!user || !token) return;

//     const fetchConfig = async () => {
//       try {
//         const res = await axios.get("/logosInstituciones");
//         if (res.data?.logo_url) {
//           setLogoConfig(res.data.logo_url);
//         }
//       } catch (err) {
//         console.warn("⚠️ Logo institucional no cargado");
//       }
//     };

//     fetchConfig();
//   }, [user, token]);

//   /* ================= SOCKET ================= */
//   useEffect(() => {
//     if (!user || !token) return;

//     socketRef.current = io(API_URL, {
//       auth: { token },
//       query: {
//         tenant_id: user.tenant_id,
//         userId: user.id,
//       },
//       transports: ["websocket"],
//     });

//     socketRef.current.on("newNotification", (notif) => {
//       setNotifications((prev) => [{ ...notif, leido: false }, ...prev]);
//     });

//     socketRef.current.on("newChatMessage", (msg) => {
//       setChatMessages((prev) => [...prev, msg]);
//     });

//     return () => {
//       if (socketRef.current) socketRef.current.disconnect();
//     };
//   }, [user, token]);

//   useEffect(() => {
//     chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [chatMessages]);

//   /* ================= HANDLERS ================= */
//   const marcarLeidas = async () => {
//     try {
//       if (notifications.some(n => !n.leido)) {
//         await axios.put("/notifications/read");
//         setNotifications(prev => prev.map(n => ({ ...n, leido: true })));
//       }
//     } catch (err) {
//       console.error("❌ Error marcando leídas");
//     }
//   };

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

//   const handleSendMessage = () => {
//     if (!newMessage.trim()) return;
//     // Emitir al socket si el backend lo requiere, o manejo local:
//     setChatMessages(prev => [...prev, { sender: "Tú", message: newMessage, self: true }]);
//     setNewMessage("");
//   };

//   /* ================= URLS DINÁMICAS ================= */
//   const nombreCompleto = `${user?.nombres_estudiante || user?.nombre || ""} ${user?.apellidos_estudiante || user?.apellido || ""}`.trim();

//   const urlLogoFinal = useMemo(() => {
//     const path = logoConfig || user?.logo_url;
//     if (!path) return null;
//     return path.startsWith("http") ? path : `${API_URL}${path.startsWith("/") ? path : `/${path}`}`;
//   }, [logoConfig, user]);

//   const fotoUsuario = useMemo(() => {
//     if (user?.foto) {
//       return `${API_URL}${user.foto.startsWith("/") ? user.foto : `/${user.foto}`}`;
//     }
//     return `https://ui-avatars.com/api/?name=${encodeURIComponent(nombreCompleto || "Usuario")}&background=random`;
//   }, [user, nombreCompleto]);

//   if (!user) return null;

//   const contextoNombre = user.sede_nombre || user.institucion_nombre || "Sistema Escolar";

//   return (
//     <>
//       <header className="header">
//         <div className="header-container">
          
//           {/* LOGO SECCIÓN */}
//           <div className="header-logo" onClick={() => navigate("/")} role="button">
//             <img
//               src={urlLogoFinal || `https://ui-avatars.com/api/?name=${encodeURIComponent(contextoNombre)}`}
//               alt="Logo"
//               className="logo-img"
//               onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(contextoNombre)}`; }}
//             />
//             <div className="logo-text-container">
//               <h1 className="logo-text">{contextoNombre}</h1>
//               {user.sede_id && <span className="logo-subtext">Sede Activa</span>}
//             </div>
//           </div>

//           {/* ACCIONES SECCIÓN */}
//           <div className="header-actions">
//             <div className="notification-wrapper">
//               <button className="icon-btn" onClick={() => { setShowNotifDropdown(!showNotifDropdown); marcarLeidas(); }}>
//                 <FiBell />
//               </button>
//               {notifications.filter(n => !n.leido).length > 0 && (
//                 <span className="badge">{notifications.filter(n => !n.leido).length}</span>
//               )}
//               {showNotifDropdown && (
//                 <div className="dropdown">
//                   {notifications.length === 0 ? (
//                     <div className="dropdown-item">Sin notificaciones</div>
//                   ) : (
//                     notifications.map((n, i) => (
//                       <div key={i} className={`dropdown-item ${!n.leido ? 'unread' : ''}`}>
//                         🔔 {n.mensaje || n.message}
//                       </div>
//                     ))
//                   )}
//                 </div>
//               )}
//             </div>

//             <button className="icon-btn" onClick={() => setShowChat(!showChat)}>
//               <FiMessageSquare />
//             </button>

//             <div className="user-info" onClick={() => setShowProfileModal(true)}>
//               <img src={fotoUsuario} alt="Usuario" className="user-avatar" />
//               <div className="user-data">
//                 <span className="user-name">{nombreCompleto}</span>
//                 <span className="user-role">{user.role}</span>
//               </div>
//             </div>

//             <button className="logout-btn" onClick={handleLogout}>
//               <FiLogOut style={{ marginRight: '5px' }} /> Salir
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* COMPONENTES MODALES */}
//       {showChat && (
//         <div className="chat-modal">
//           <div className="chat-header">
//             <span>Chat de Soporte / Mensajería</span>
//             <button onClick={() => setShowChat(false)}>×</button>
//           </div>
//           <div className="chat-messages">
//             {chatMessages.map((msg, i) => (
//               <div key={i} className={`msg-bubble ${msg.self ? 'self' : ''}`}>
//                 <strong>{msg.sender}:</strong> {msg.message}
//               </div>
//             ))}
//             <div ref={chatEndRef} />
//           </div>
//           <div className="chat-input">
//             <input
//               value={newMessage}
//               onChange={(e) => setNewMessage(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
//               placeholder="Escribe un mensaje..."
//             />
//             <button onClick={handleSendMessage}>Enviar</button>
//           </div>
//         </div>
//       )}

//       {showProfileModal && (
//         <ProfileModal 
//           user={user} 
//           onClose={() => setShowProfileModal(false)} 
//           refreshUser={refreshUser} 
//         />
//       )}
//     </>
//   );
// }

// /* ================= COMPONENTE PERFIL ================= */
// function ProfileModal({ user, onClose, refreshUser }) {
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleUpload = async (type) => {
//     if (!file) return alert("Selecciona un archivo primero");
//     const formData = new FormData();
//     formData.append(type === "foto" ? "foto" : "logo", file);

//     try {
//       setLoading(true);
//       const endpoint = type === "foto" ? "/perfiles/foto" : "/instituciones/upload-logo";
//       await axios.post(endpoint, formData, { headers: { "Content-Type": "multipart/form-data" } });
//       await refreshUser();
//       alert("Actualizado correctamente");
//       onClose();
//     } catch {
//       alert("Error al subir el archivo");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h2>Mi Perfil</h2>
//           <button onClick={onClose}>&times;</button>
//         </div>
//         <div className="modal-body">
//           <p><strong>Nombre:</strong> {user.nombre} {user.apellido}</p>
//           <div className="upload-group">
//             <input type="file" onChange={(e) => setFile(e.target.files[0])} />
//             <button disabled={loading} onClick={() => handleUpload("foto")} className="btn-upload">
//               Cambiar mi foto
//             </button>
//             {user.role === "rector" && (
//               <button disabled={loading} onClick={() => handleUpload("logo")} className="btn-upload-logo">
//                 Cambiar Logo Colegio
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosAuth";
import io from "socket.io-client";
import { useAuth } from "../context/AuthContext";
import { SOCKET_URL } from "../components/config";
import "../style/Header.css";
import { FiBell, FiMessageSquare, FiLogOut, FiUser, FiUpload } from "react-icons/fi";

const SOCKET_SERVER = SOCKET_URL;

export default function Header() {
  const { user, token, logout, refreshUser } = useAuth();
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState([]);
  const [showNotifDropdown, setShowNotifDropdown] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [logoConfig, setLogoConfig] = useState(null);

  const chatEndRef = useRef(null);
  const socketRef = useRef(null);

  /* ================= NOTIFICACIONES ================= */
  useEffect(() => {
    if (!user || !token) return;

    const fetchNotificaciones = async () => {
      try {
        const res = await axios.get("/notifications");
        setNotifications(res.data || []);
      } catch (err) {
        console.error("Error cargando notificaciones:", err.message);
      }
    };

    fetchNotificaciones();
  }, [user, token]);

  /* ================= LOGO ================= */
  useEffect(() => {
    if (!user || !token) return;

    const fetchConfig = async () => {
      try {
        const res = await axios.get("/logosInstituciones");
        if (res.data?.logo_url) setLogoConfig(res.data.logo_url);
      } catch {
        console.warn("Logo institucional no cargado");
      }
    };

    fetchConfig();
  }, [user, token]);

  /* ================= SOCKET ================= */
  useEffect(() => {
    if (!user || !token) return;

    socketRef.current = io(SOCKET_SERVER, {
      auth: { token: localStorage.getItem("token") },
      query: {
        tenant_id: user.tenant_id,
        userId: user.id,
      },
      transports: ["websocket", "polling"],
    });

    socketRef.current.on("newNotification", (notif) => {
      setNotifications((prev) => [{ ...notif, leido: false }, ...prev]);
    });

    socketRef.current.on("newChatMessage", (msg) => {
      setChatMessages((prev) => [...prev, msg]);
    });

    return () => socketRef.current?.disconnect();
  }, [user, token]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  const marcarLeidas = async () => {
    try {
      if (notifications.some((n) => !n.leido)) {
        await axios.put("/notifications/read");
        setNotifications((prev) => prev.map((n) => ({ ...n, leido: true })));
      }
    } catch {
      console.error("Error marcando notificaciones");
    }
  };

  const handleSendMessage = () => {
    if (!newMessage.trim()) return;

    setChatMessages((prev) => [
      ...prev,
      { sender: "Tú", message: newMessage, self: true },
    ]);

    setNewMessage("");
  };

  const nombreCompleto = user?.nombreCompleto || "Usuario";
  const contextoNombre = user?.sede_nombre || user?.institucion_nombre || "Sistema Escolar";

  const urlLogoFinal = useMemo(() => {
    const path = logoConfig || user?.logo_url;
    if (!path) return `https://ui-avatars.com/api/?name=${encodeURIComponent(contextoNombre)}`;
    return `${path}?t=${Date.now()}`;
  }, [logoConfig, user?.logo_url, contextoNombre]);

  const fotoUsuario = useMemo(() => {
    if (user?.foto) {
      return `${user.foto}?t=${Date.now()}`;
    }

    return `https://ui-avatars.com/api/?name=${encodeURIComponent(nombreCompleto)}&background=random`;
  }, [user?.foto, nombreCompleto]);

  if (!user) return null;

  return (
    <>
      <header className="header">
        <div className="header-container">

          <div className="header-logo" onClick={() => navigate("/")} role="button">
            <img src={urlLogoFinal} alt="Logo" className="logo-img" />
            <div className="logo-text-container">
              <h1 className="logo-text">{contextoNombre}</h1>
              {user.sede_id && <span className="logo-subtext">Sede Activa</span>}
            </div>
          </div>

          <div className="header-actions">
            <div className="notification-wrapper">
              <button className="icon-btn" onClick={() => {
                setShowNotifDropdown(!showNotifDropdown);
                marcarLeidas();
              }}>
                <FiBell />
              </button>

              {notifications.filter((n) => !n.leido).length > 0 && (
                <span className="badge">{notifications.filter((n) => !n.leido).length}</span>
              )}

              {showNotifDropdown && (
                <div className="dropdown">
                  {notifications.length === 0 ? (
                    <div className="dropdown-item">Sin notificaciones</div>
                  ) : (
                    notifications.map((n, i) => (
                      <div key={i} className={`dropdown-item ${!n.leido ? "unread" : ""}`}>
                        🔔 {n.mensaje || n.message}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>

            <button className="icon-btn" onClick={() => setShowChat(!showChat)}>
              <FiMessageSquare />
            </button>

            <div className="user-info" onClick={() => setShowProfileModal(true)}>
              <img src={fotoUsuario} alt="Usuario" className="user-avatar" />
              <div className="user-data">
                <span className="user-name">{nombreCompleto}</span>
                <span className="user-role">{user.role}</span>
              </div>
            </div>

            <button className="logout-btn" onClick={logout}>
              <FiLogOut style={{ marginRight: "5px" }} /> Salir
            </button>
          </div>
        </div>
      </header>

      {showProfileModal && (
        <ProfileModal
          user={user}
          fotoUsuario={fotoUsuario}
          onClose={() => setShowProfileModal(false)}
          refreshUser={refreshUser}
        />
      )}
    </>
  );
}

function ProfileModal({ user, fotoUsuario, onClose, refreshUser }) {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(fotoUsuario);
  const [loading, setLoading] = useState(false);

  const handleFile = (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;
    setFile(archivo);
    setPreview(URL.createObjectURL(archivo));
  };

  const handleUpload = async () => {
    if (!file) return alert("Selecciona un archivo primero");

    const formData = new FormData();
    formData.append("foto", file);

    try {
      setLoading(true);

      await axios.post("/perfil-usuario/foto", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      await refreshUser();
      alert("Foto actualizada correctamente");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Error subiendo foto");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content perfil-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2><FiUser /> Mi Perfil</h2>
          <button onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body perfil-body">
          <img src={preview} alt="Perfil" className="perfil-preview" />

          <p><strong>Nombre:</strong> {user.nombreCompleto}</p>
          <p><strong>Rol:</strong> {user.role}</p>
          <p><strong>Usuario:</strong> {user.username}</p>

          <input type="file" onChange={handleFile} />

          <button disabled={loading} onClick={handleUpload} className="btn-upload">
            <FiUpload /> Cambiar mi foto
          </button>
        </div>
      </div>
    </div>
  );
}
